import { useState } from "react";

const useLocationTable = () => {
  const [locationData, setLocationsData] = useState();

  return { locationData, setLocationsData };
};

export default useLocationTable;
